export default __webpack_public_path__ + "static/media/Account-no-data-icon.e5eacbdf.svg";